import {Conversation} from "@twilio/conversations";
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output
} from "@angular/core";
import {ChatHttpService} from "../../services/chat-http.service";
import {CurrentSiteContextService} from "../../../commons/angular/services/current-site-context.service";
import {ChatUserModel} from "../../models/chat-user.model";

require('./chat-user-input.scss');
@Component({
  standalone: false,
  selector: 'chat-user-input',
  templateUrl: './chat-user-input.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatUserInputComponent implements OnInit {

  @Input() conversation: Conversation;
  @Input() active: boolean;
  @Output() onSelect: EventEmitter<Conversation> = new EventEmitter();

  private siteId: string;
  public users: ChatUserModel[];
  public query?: string;
  public loading: boolean = false;
  public isFocused: boolean = false;

  private readonly debounceTime: number = 500;

  constructor(
    @Inject(CurrentSiteContextService) private currentSiteContextService: CurrentSiteContextService,
    @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef,
    @Inject(ChatHttpService) private chatHttpService: ChatHttpService
  ) {}

  ngOnInit(): void {
    this.siteId = this.currentSiteContextService.currentSiteId;
  }

  onFocusOut() {
    setTimeout(()=>{
      this.isFocused = false;
      this.cdr.detectChanges();
    }, this.debounceTime);

  }

  onFocusIn() {
    this.isFocused = true;
    if (this.query) {
      this.onQueryChange(this.query);
    }
  }

  onQueryChange(query) {
    setTimeout(()=>{
      if (!!this.query && this.query === query) {
        this.getUsers();
      }
    }, this.debounceTime);
  }

  getUsers() {
    this.loading = true;
    this.users = undefined;
    this.chatHttpService.getUsers(this.siteId, this.query)
      .subscribe((users: ChatUserModel[]) => {
        this.users = users;
        this.loading = false;
        this.cdr.detectChanges();
      })
  }

  onSelectUser(user) {
    this.onSelect.emit(user);
  }

}
